import React, { useEffect, useState } from "react";
// import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button, Util } from "reactstrap";
import "./Card.scss";
import '../Icons/IconFontawesome';
import Utils from '../Utility';
import { post, get, put } from "../../helpers/api_helper";
import 'react-vertical-timeline-component/style.min.css';
import Modal from './DeleteModal';
import DataTable from 'react-data-table-component';
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from 'react-toastify';
import AddSlotForm from '../Forms/AddSlotForm';
import Loader from "../../components/Loader";

const SlotManageMent = (props) => {
  const { user, role, leadId, loading, setLoading } = props;
  const [data, setData] = useState([]);
  const [days, setDays] = useState([]);
  const [dayColumn, setDayColumn] = useState([]);
  const [slots, setSlots] = useState([]);
  const [slotColumn, setSlotColumn] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [tableLoading, setTableLoading] = useState(false);
  const [currentSlot, setCurrentSlot] = useState(null);
  const [isAddFormSlot, setIsAddFormSlot] = useState(false);
  const [currentTab, setCurrentTab] = useState('day');
  const [selectedDay, setSelectedDay] = useState(null);
  const [isDayChanged, setIsDayChanged] = useState(false);

  const btnGradient = `linear-gradient(135deg, ${Utils.themeColor} 0%, #8b0000 100%)`;

  useEffect(() => {
    if (user?.role == 'Admin') {
      getDays();
      getSlot(1, perPage);
    }
  }, [user]);

  const getDays = () => {
    get("/event/list", { token: user?.token })
      .then(json => {
        console.log('response from get day list', json);
        setLoading(false);
        if (json?.statusCode == 200) {
          if (json?.data?.length) {
            setDays(json?.data);
            setSelectedDay(prev => {
              if (!prev) return json?.data[0];
              return json?.data.find(d => d._id == prev._id) || json?.data[0];
            });
          }
        }
      })
      .catch(error => {
        console.log('error while getting lead detail', error);
        setLoading(false);
      })
  }

  const getSlot = (page = currentPage, limit = perPage) => {
    setTableLoading(true);
    get(`/slot/list?page=${page}&limit=${limit}`, { token: user?.token })
      .then(json => {
        console.log('response from get slot list', json);
        setTableLoading(false);
        setLoading(false);
        if (json?.statusCode == 200) {
          if (typeof json?.total === 'number') {
            setSlots(json?.data || []);
            setTotalRows(json.total);
          } else {
            const allSlots = json?.data || [];
            setTotalRows(allSlots.length);
            const startIndex = (page - 1) * limit;
            setSlots(allSlots.slice(startIndex, startIndex + limit));
          }
        }
      })
      .catch(error => {
        setTableLoading(false);
        setLoading(false);
        console.log('error while getting lead detail', error);
      })
  }

  const handlePageChange = (page) => {
    setCurrentPage(page);
    getSlot(page, perPage);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
    getSlot(page, newPerPage);
  };

  useEffect(() => {
    setDayColumn([
      {
        name: 'Title',
        selector: row => row.title,
      },
      {
        name: 'Description',
        selector: row => row.desc.length > 30 ? row.desc.substring(0, 30) + '...' : row.desc,
      },
      {
        cell: (row) => <>
          <AvForm style={{}}>
            <div style={{}}>
              <AvField onChange={(e) => handleUpdateDayStatus(e.target.value, row)} style={{ minWidth: 150, padding: 5, paddingLeft: 8, paddingRight: 8 }}
                type="select"
                name="isActive"
                placeholder={"Select Status"}
                value={row?.isActive ? "Active" : "Inactive"}
              >
                <option value={"Active"}>Active</option>
                <option value={"Inactive"}>Inactive</option>
              </AvField>
            </div>
          </AvForm>
          {/* <Button onClick={() => handleDeleteUser(row)} style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-cancel" style={{ fontSize: 20 }}></span></Button> */}
        </>,
        name: 'Status',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
      {
        cell: (row) => <>
          <Button onClick={() => handleUpdateDay(row)}
            title={""}
            style={{ background: btnGradient, border: 'none', marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-pencil" style={{ fontSize: 20 }}></span></Button>
        </>,
        name: 'Action',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
    ]);
  }, [days]);

  const handleUpdateDay = () => {
    setLoading(true);
    let body = selectedDay;
    body.eventId = selectedDay?._id;
    body.token = user?.token;
    put("/event/update", body)
      .then((json) => {
        console.log('response from updating day', json);
        setLoading(false);
        if (json.statusCode == 200) {
          toast.success(json?.message);
          getDays();
          setIsDayChanged(false);
        }
      })
      .catch(error => {
        toast.error(error);
        console.error('error while adding day', error);
        setLoading(false);
      })
  }

  const handleUpdateDayStatus = (val, item) => {
    // console.log('updating status of the day', val, item);
    const body = {
      eventId: item?._id,
      token: user?.token,
      isActive: val == "Active" ? true : false
    }
    put('/event/update', body)
      .then((res) => {
        console.log('response from update day status', res);
        if (res?.statusCode == 200) {
          toast.success(res?.message);
          getDays();
        }
        else
          toast.error(res?.error);
      })
  }

  useEffect(() => {
    setSlotColumn([
      {
        name: 'Description',
        selector: row => row.title.length > 30 ? row.title.substring(0, 30) + '...' : row.title,
      },
      {
        name: 'Start Time',
        selector: row => row.startAt,
      },
      {
        name: 'End Time',
        selector: row => row.endAt,
      },
      {
        name: 'Booking Status',
        selector: row => row?.bookings.length > 0 ? row.bookings[0]?.mobile + ` (${row.bookings[0]?.name})` : 'Empty',
      },
      {
        cell: (row) => <>
          <AvForm style={{}}>
            <div style={{}}>
              <AvField onChange={(e) => handleUpdateSlotStatus(e.target.value, row)} style={{ minWidth: 150, padding: 5, paddingLeft: 8, paddingRight: 8 }}
                type="select"
                name="isActive"
                placeholder={"Select Status"}
                value={(selectedDay?.slot?.findIndex(x => x._id == row?._id) != -1 || selectedDay?.slots?.findIndex(x => x == row?._id || x?._id == row?._id) != -1) ? "Active" : "Inactive"}
              >
                <option value={"Active"}>Active</option>
                <option value={"Inactive"}>Inactive</option>
              </AvField>
            </div>
          </AvForm>
          {/* <Button onClick={() => handleDeleteUser(row)} style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-cancel" style={{ fontSize: 20 }}></span></Button> */}
        </>,
        name: 'Status',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
      {
        cell: (row) => <>
          <Button onClick={() => handleUpdateSlot(row)}
            title={""}
            style={{ background: btnGradient, border: 'none', marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-pencil" style={{ fontSize: 20 }}></span></Button>
          <Button onClick={() => handleDeleteSlot(row)}
            title={""}
            style={{ background: btnGradient, border: 'none', marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-trash-can" style={{ fontSize: 20 }}></span></Button>
        </>,
        name: 'Action',
        ignoreRowClick: true,
        // allowOverflow: true,
        // button: true,
      },
    ]);
  }, [slots, days, selectedDay]);

  const handleUpdateSlot = (item) => {
    setCurrentSlot(item);
    setIsAddFormSlot(true);
  }

  const handleUpdateSlotStatus = (val, item) => {
    const body = {
      slotId: item?._id,
      token: user?.token,
      isActive: val == "Active" ? true : false,
      dayId: selectedDay?._id
    }
    put('/slot/update', body)
      .then((res) => {
        console.log('response from update slot status', res);
        if (res?.statusCode == 200) {
          toast.success(res?.message);
          getSlot(currentPage, perPage);
          getDays();
        } else
          toast.error(res?.error);
      })
  }

  const handleDeleteSlot = (item) => {
    console.log('deleting slot', item);
    post('/slot/delete', { slotId: item?._id, token: user?.token })
      .then((res) => {
        if (res.statusCode == 200) {
          toast.success(res?.message);
          getSlot(currentPage, perPage);
        } else {
          toast.error(res?.error);
        }
      })
  }

  const handleDayChange = (val) => {
    let found = days.find(x => x._id == val);
    setSelectedDay(found);
  }

  const handleDescChange = (desc) => {
    setSelectedDay({ ...selectedDay, desc });
    let day = Object.assign([], days);
    let index = day.findIndex(x => x._id == selectedDay?._id);
    if (day[index]?.desc != desc)
      setIsDayChanged(true);
    else
      setIsDayChanged(false);
  }

  return (
    <React.Fragment>
      <div className="">
        {/* <Loader visible={loading} /> */}
        <div style={{ marginTop: 0 }}>
          {/* Bounding box for the Timeline */}
          {/* <div style={{ width: '100%', margin: 'auto' }}>
            <div className="d-flex" style={{}}>
              <span style={{
                fontSize: 20, borderRight: `1px solid ${Utils.themeColor}`,
                borderLeft: `1px solid ${Utils.themeColor}`,
                borderBottom: `1px solid ${Utils.themeColor}`,
                width: '20%', textAlign: 'center',
                backgroundColor: currentTab == 'day' ? Utils.themeColor : 'white', paddingTop: 5, paddingBottom: 5,
                color: currentTab == 'day' ? 'white' : 'black', cursor: 'pointer'
              }} onClick={() => setCurrentTab('day')}>
                Day
              </span>
              <span style={{
                fontSize: 20, borderRight: `1px solid ${Utils.themeColor}`,
                borderLeft: `1px solid ${Utils.themeColor}`,
                borderBottom: `1px solid ${Utils.themeColor}`,
                width: '20%', textAlign: 'center',
                backgroundColor: currentTab == 'slot' ? Utils.themeColor : 'white', paddingTop: 5, paddingBottom: 5,
                color: currentTab == 'slot' ? 'white' : 'black', cursor: 'pointer'
              }} onClick={() => { setCurrentTab('slot'); getSlot() }}>
                Slot
              </span>
            </div>
          </div> */}
          {/* {currentTab == 'day' &&
            <div style={{ width: '90%', marginTop: 20 }}>
              {isAddForm ?
                <AddLeadForm
                  role={"Day"}
                  user={user}
                  data={currentDay}
                  close={setIsAddForm}
                  loading={loading}
                  setLoading={setLoading}
                  getDays={getDays}
                />
                :
                <DataTable
                  columns={dayColumn}
                  data={days}
                  pagination
                  customStyles={{
                    headCells: {
                      style: {
                        color: 'black',
                        fontWeight: 'bold',
                        fontSize: 15,
                        // minWidth: 80
                      },
                    },
                    // cells: {
                    //   style: {
                    //     maxWidth: 50
                    //   }
                    // }
                  }}
                />
              }
            </div>
          } */}
          {/* {currentTab == 'slot' && */}
          <div style={{ width: '90%', marginTop: 20, textAlign: 'right' }}>
            <div >
              <AvForm>
                <Row className="align-items-end">
                  <Col md={2}>
                    <div className="form-group text-start">
                      <AvField
                        type="select"
                        name="day"
                        label={"Select Day"}
                        required
                        onChange={(e) => handleDayChange(e.target.value)}
                      >
                        {days.map((item) => (
                          <option key={item?._id} value={item?._id} color={'black'}>{item?.title}</option>
                        ))}
                      </AvField>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="form-group text-start">
                      <AvField
                        type="textarea"
                        name="desc"
                        label="Description"
                        required
                        rows="1"
                        value={selectedDay?.desc}
                        onChange={(e) => handleDescChange(e.target.value)}
                      >
                      </AvField>
                    </div>
                  </Col>
                  <Col md={2}>
                    <div className="form-group text-start">
                      <AvField onChange={(e) => handleUpdateDayStatus(e.target.value, selectedDay)} style={{ minWidth: 150, padding: 5, paddingLeft: 8, paddingRight: 8 }}
                        type="select"
                        name="isActive"
                        label={'Status'}
                        placeholder={"Select Status"}
                        value={selectedDay?.isActive ? "Active" : "Inactive"}
                      >
                        <option value={"Active"}>Active</option>
                        <option value={"Inactive"}>Inactive</option>
                      </AvField>
                    </div>
                  </Col>
                  <Col md={2}>
                    <div className="form-group text-start">
                      {isDayChanged &&
                        <Button style={{ background: btnGradient, border: 'none' }} onClick={() => handleUpdateDay()}>
                          Update
                        </Button>
                      }
                      <Button style={{ background: btnGradient, border: 'none', marginLeft: 20 }} onClick={() => { setCurrentSlot(null); setIsAddFormSlot(true) }}>
                        Add New Slot
                      </Button>
                    </div>
                  </Col>
                </Row>
              </AvForm>
            </div>
            {isAddFormSlot ?
              <AddSlotForm
                role={"Slot"}
                user={user}
                data={currentSlot}
                close={setIsAddFormSlot}
                loading={loading}
                setLoading={setLoading}
                getData={() => getSlot(currentPage, perPage)}
                selectedDay={selectedDay}
              />
              :
              <>

                <DataTable
                  columns={slotColumn}
                  data={slots}
                  progressPending={tableLoading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  customStyles={{
                    headCells: {
                      style: {
                        color: 'black',
                        fontWeight: 'bold',
                        fontSize: 15,
                        // minWidth: 80
                      },
                    },
                    // cells: {
                    //   style: {
                    //     maxWidth: 50
                    //   }
                    // }
                  }}
                />
              </>
            }
          </div>
          {/* } */}
        </div>
      </div>
    </React.Fragment>
  )
}

export default SlotManageMent;
